import React from 'react';

export const DiscountsTab: React.FC = (): JSX.Element => {
	return <></>;
};
